import { InferOutput, maxValue, minValue, number, pipe, string, transform, union } from 'valibot'

export const MIN_PLAYER_COLOR_VALUE = 0
export const MAX_PLAYER_COLOR_VALUE = 0xFFFFFF // 16777215

// coerce string to number?
// v.pipe(v.unknown(), v.transform(Number));


export const StringOrHexColorAsNumberSchema = union([
  // If it's a string, clean it up, and transform it into a number
  pipe(
    string(),
    transform((str) => {
      // if starts with #, replace # with 0x
      const normalized = str.startsWith('#') ? '0x' + str.slice(1) : str
      return Number(normalized)
    }),
    number(), // Make sure the result is still a number
  ),
  number(),
])

export const PlayerColorSchema = pipe(
  StringOrHexColorAsNumberSchema,
  // number(),
  minValue(MIN_PLAYER_COLOR_VALUE),
  maxValue(MAX_PLAYER_COLOR_VALUE)
)

export type PlayerColor = InferOutput<typeof PlayerColorSchema>
